import * as React from "react";

const UserAvatarIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#FCEDDD" />
    <path
      d="M30.9626 45.8026C28.6047 47.2066 22.4223 50.0735 26.1878 53.661C28.0272 55.4133 30.0758 56.6666 32.6515 56.6666H47.3485C49.9242 56.6666 51.9728 55.4133 53.8122 53.661C57.5777 50.0735 51.3953 47.2066 49.0373 45.8026C43.508 42.5101 36.492 42.5101 30.9626 45.8026Z"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.5 30.8334C47.5 34.9755 44.1422 38.3334 40 38.3334C35.8579 38.3334 32.5 34.9755 32.5 30.8334C32.5 26.6912 35.8579 23.3334 40 23.3334C44.1422 23.3334 47.5 26.6912 47.5 30.8334Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
  </svg>
);

export default UserAvatarIcon;
